var React = require('react');

function Penalty (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M13.429 16.714v-4.19c0-.556-.221-1.089-.614-1.482s-.926-.614-1.481-.614c-.556 0-1.09.221-1.482.614-.393.393-.614.926-.614 1.482v6.286c0 2.095 2.096 4.19 2.096 4.19h6.285l2.731-8.194c.264-.79.202-1.653-.17-2.398l-4.656-9.313","key":0}),React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M15.524 9.38V1H4v15.714h2.095","key":1})]);
}

Penalty.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Penalty;

Penalty.default = Penalty;
